import React from "react";

import "./SearchBox.css";

const SearchBox = ({ value, onChange }) => {
  return (
    <div
      className="input-group  pl-0 col-md-5"
      style={{
        borderRadius: "50%",
      }}
    >
      <div className="input-group-prepend">
        <div className="input-group-text border-right-0 rounded-pill-left">
          <i className="text-right fa fa-search"></i>
        </div>
      </div>
      <input
        className="form-control py-2 border-left-0  border rounded-pill-right pl-0"
        type="search"
        placeholder="Search"
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
};

export default SearchBox;
